import { isRenderingServer } from '#/rendering/state/renderingState';

import { getJsonInternal } from './getJsonInternal';

export function getJson<T = unknown>(url: string): Promise<T> {
  if (isRenderingServer()) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(
      (response) => response.json(),
    );
  }

  return new Promise((resolve, reject) => {
    getJsonInternal(url, resolve, reject, 5 /* retriesRemaining */);
  });
}
